import { BaseAPI } from "../../BaseAPI";
import * as environment from '../../../config/environment';
class BasvuruTuruAPI extends BaseAPI {
  

  constructor () {
    const baseUrl = environment.API_URL + "BasvuruTuruListe";
    super(baseUrl);
  }


  getBasvuruTuruListe(basvuruTuruKodu?: number,ctOzelKod?: number){
    
        var request= new BasvuruTuruRequest(basvuruTuruKodu,ctOzelKod);
    return this.get("", request);
   
  }

}
export default new BasvuruTuruAPI();
class BasvuruTuruRequest {
  public basvuruTuruKodu?: number;
  public ctOzelKod?: number;
  constructor(basvuruTuruKodu?: number,ctOzelKod?: number) {
   
      this.basvuruTuruKodu = basvuruTuruKodu;
      this.ctOzelKod = ctOzelKod;

  }
}
export { BasvuruTuruRequest };